const dayjs = require('dayjs')
const isBetween = require('dayjs/plugin/isBetween')

dayjs.extend(isBetween)

export const isBetweenDates = (today, from, to) => {
  const validFrom = dayjs(
    new Date(
      from
        ? from
        : dayjs() < dayjs(new Date(to))
          ? dayjs()
          : dayjs(to).subtract(2, 'day')
    )
  )
  const validTo = dayjs(new Date(to))

  return dayjs(today).isBetween(validFrom, validTo, 'day', '[]')
}
